module.exports = __webpack_public_path__ + "img/order-icon.b7d26e25.png";